// extracted by mini-css-extract-plugin
export default {"overlay":"_y-z","bodyOpen":"az-z","content":"bz-z","header":"cz-z","close":"dz-z","closeNoHeading":"ez-z"};